import { useMutation } from "react-query";
import axios from "axios";

const resendVerifyUserEmail = async ({ userId, userEmailId }) => {
  let pathAndHost = window.location.protocol + window.location.host;

  let url = new URL(`/api/v2/users/${userId}/emails/${userEmailId}/resend_verification`, pathAndHost);

  let resendVerificationEmailResult;
  try {
    resendVerificationEmailResult = await axios.post(url);
  } catch (err) {
    console.error(err.response.data);
    throw err;
  }

  return resendVerificationEmailResult.data;
};

export default function useResendVerifyUserEmail() {
  return useMutation(async ({ userId, userEmailId }) => {
    // eslint-disable-next-line no-useless-catch
    try {
      await resendVerifyUserEmail({
        userId,
        userEmailId,
      });
    } catch (err) {
      throw err;
    }
  });
}
